"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es6.object.define-property");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var widgets_1 = require("@phosphor/widgets");

var renderers = __importStar(require("./renderers"));
/**
 * A common base class for mime renderers.
 */


var RenderedCommon = /*#__PURE__*/function (_widgets_1$Widget) {
  _inherits(RenderedCommon, _widgets_1$Widget);

  var _super = _createSuper(RenderedCommon);

  /**
   * Construct a new rendered common widget.
   *
   * @param options - The options for initializing the widget.
   */
  function RenderedCommon(options) {
    var _this;

    _classCallCheck(this, RenderedCommon);

    _this = _super.call(this);
    _this.mimeType = options.mimeType;
    _this.sanitizer = options.sanitizer;
    _this.resolver = options.resolver;
    _this.linkHandler = options.linkHandler;
    _this.latexTypesetter = options.latexTypesetter;
    _this.node.dataset['mimeType'] = _this.mimeType;
    return _this;
  }
  /**
   * Render a mime model.
   *
   * @param model - The mime model to render.
   *
   * @returns A promise which resolves when rendering is complete.
   */


  _createClass(RenderedCommon, [{
    key: "renderModel",
    value: function renderModel(model) {
      // TODO compare model against old model for early bail?
      // Toggle the trusted class on the widget.
      this.toggleClass('jp-mod-trusted', model.trusted); // Render the actual content.

      return this.render(model);
    }
  }]);

  return RenderedCommon;
}(widgets_1.Widget);

exports.RenderedCommon = RenderedCommon;
/**
 * A common base class for HTML mime renderers.
 */

var RenderedHTMLCommon = /*#__PURE__*/function (_RenderedCommon) {
  _inherits(RenderedHTMLCommon, _RenderedCommon);

  var _super2 = _createSuper(RenderedHTMLCommon);

  /**
   * Construct a new rendered HTML common widget.
   *
   * @param options - The options for initializing the widget.
   */
  function RenderedHTMLCommon(options) {
    var _this2;

    _classCallCheck(this, RenderedHTMLCommon);

    _this2 = _super2.call(this, options);

    _this2.addClass('jp-RenderedHTMLCommon');

    return _this2;
  }

  return RenderedHTMLCommon;
}(RenderedCommon);

exports.RenderedHTMLCommon = RenderedHTMLCommon;
/**
 * A mime renderer for displaying HTML and math.
 */

var RenderedHTML = /*#__PURE__*/function (_RenderedHTMLCommon) {
  _inherits(RenderedHTML, _RenderedHTMLCommon);

  var _super3 = _createSuper(RenderedHTML);

  /**
   * Construct a new rendered HTML widget.
   *
   * @param options - The options for initializing the widget.
   */
  function RenderedHTML(options) {
    var _this3;

    _classCallCheck(this, RenderedHTML);

    _this3 = _super3.call(this, options);

    _this3.addClass('jp-RenderedHTML');

    return _this3;
  }
  /**
   * Render a mime model.
   *
   * @param model - The mime model to render.
   *
   * @returns A promise which resolves when rendering is complete.
   */


  _createClass(RenderedHTML, [{
    key: "render",
    value: function render(model) {
      return renderers.renderHTML({
        host: this.node,
        source: String(model.data[this.mimeType]),
        trusted: model.trusted,
        resolver: this.resolver,
        sanitizer: this.sanitizer,
        linkHandler: this.linkHandler,
        shouldTypeset: this.isAttached,
        latexTypesetter: this.latexTypesetter
      });
    }
    /**
     * A message handler invoked on an `'after-attach'` message.
     */

  }, {
    key: "onAfterAttach",
    value: function onAfterAttach(msg) {
      if (this.latexTypesetter) {
        this.latexTypesetter.typeset(this.node);
      }
    }
  }]);

  return RenderedHTML;
}(RenderedHTMLCommon);

exports.RenderedHTML = RenderedHTML;
/**
 * A mime renderer for displaying LaTeX output.
 */

var RenderedLatex = /*#__PURE__*/function (_RenderedCommon2) {
  _inherits(RenderedLatex, _RenderedCommon2);

  var _super4 = _createSuper(RenderedLatex);

  /**
   * Construct a new rendered LaTeX widget.
   *
   * @param options - The options for initializing the widget.
   */
  function RenderedLatex(options) {
    var _this4;

    _classCallCheck(this, RenderedLatex);

    _this4 = _super4.call(this, options);

    _this4.addClass('jp-RenderedLatex');

    return _this4;
  }
  /**
   * Render a mime model.
   *
   * @param model - The mime model to render.
   *
   * @returns A promise which resolves when rendering is complete.
   */


  _createClass(RenderedLatex, [{
    key: "render",
    value: function render(model) {
      return renderers.renderLatex({
        host: this.node,
        source: String(model.data[this.mimeType]),
        shouldTypeset: this.isAttached,
        latexTypesetter: this.latexTypesetter
      });
    }
    /**
     * A message handler invoked on an `'after-attach'` message.
     */

  }, {
    key: "onAfterAttach",
    value: function onAfterAttach(msg) {
      if (this.latexTypesetter) {
        this.latexTypesetter.typeset(this.node);
      }
    }
  }]);

  return RenderedLatex;
}(RenderedCommon);

exports.RenderedLatex = RenderedLatex;
/**
 * A mime renderer for displaying images.
 */

var RenderedImage = /*#__PURE__*/function (_RenderedCommon3) {
  _inherits(RenderedImage, _RenderedCommon3);

  var _super5 = _createSuper(RenderedImage);

  /**
   * Construct a new rendered image widget.
   *
   * @param options - The options for initializing the widget.
   */
  function RenderedImage(options) {
    var _this5;

    _classCallCheck(this, RenderedImage);

    _this5 = _super5.call(this, options);

    _this5.addClass('jp-RenderedImage');

    return _this5;
  }
  /**
   * Render a mime model.
   *
   * @param model - The mime model to render.
   *
   * @returns A promise which resolves when rendering is complete.
   */


  _createClass(RenderedImage, [{
    key: "render",
    value: function render(model) {
      var metadata = model.metadata[this.mimeType];
      return renderers.renderImage({
        host: this.node,
        mimeType: this.mimeType,
        source: String(model.data[this.mimeType]),
        width: metadata && metadata.width,
        height: metadata && metadata.height,
        needsBackground: model.metadata['needs_background'],
        unconfined: metadata && metadata.unconfined
      });
    }
  }]);

  return RenderedImage;
}(RenderedCommon);

exports.RenderedImage = RenderedImage;
/**
 * A mime renderer for displaying Markdown with embedded latex.
 */

var RenderedMarkdown = /*#__PURE__*/function (_RenderedHTMLCommon2) {
  _inherits(RenderedMarkdown, _RenderedHTMLCommon2);

  var _super6 = _createSuper(RenderedMarkdown);

  /**
   * Construct a new rendered markdown widget.
   *
   * @param options - The options for initializing the widget.
   */
  function RenderedMarkdown(options) {
    var _this6;

    _classCallCheck(this, RenderedMarkdown);

    _this6 = _super6.call(this, options);

    _this6.addClass('jp-RenderedMarkdown');

    return _this6;
  }
  /**
   * Render a mime model.
   *
   * @param model - The mime model to render.
   *
   * @returns A promise which resolves when rendering is complete.
   */


  _createClass(RenderedMarkdown, [{
    key: "render",
    value: function render(model) {
      return renderers.renderMarkdown({
        host: this.node,
        source: String(model.data[this.mimeType]),
        trusted: model.trusted,
        resolver: this.resolver,
        sanitizer: this.sanitizer,
        linkHandler: this.linkHandler,
        shouldTypeset: this.isAttached,
        latexTypesetter: this.latexTypesetter
      });
    }
    /**
     * A message handler invoked on an `'after-attach'` message.
     */

  }, {
    key: "onAfterAttach",
    value: function onAfterAttach(msg) {
      if (this.latexTypesetter) {
        this.latexTypesetter.typeset(this.node);
      }
    }
  }]);

  return RenderedMarkdown;
}(RenderedHTMLCommon);

exports.RenderedMarkdown = RenderedMarkdown;
/**
 * A widget for displaying SVG content.
 */

var RenderedSVG = /*#__PURE__*/function (_RenderedCommon4) {
  _inherits(RenderedSVG, _RenderedCommon4);

  var _super7 = _createSuper(RenderedSVG);

  /**
   * Construct a new rendered SVG widget.
   *
   * @param options - The options for initializing the widget.
   */
  function RenderedSVG(options) {
    var _this7;

    _classCallCheck(this, RenderedSVG);

    _this7 = _super7.call(this, options);

    _this7.addClass('jp-RenderedSVG');

    return _this7;
  }
  /**
   * Render a mime model.
   *
   * @param model - The mime model to render.
   *
   * @returns A promise which resolves when rendering is complete.
   */


  _createClass(RenderedSVG, [{
    key: "render",
    value: function render(model) {
      var metadata = model.metadata[this.mimeType];
      return renderers.renderSVG({
        host: this.node,
        source: String(model.data[this.mimeType]),
        trusted: model.trusted,
        unconfined: metadata && metadata.unconfined
      });
    }
    /**
     * A message handler invoked on an `'after-attach'` message.
     */

  }, {
    key: "onAfterAttach",
    value: function onAfterAttach(msg) {
      if (this.latexTypesetter) {
        this.latexTypesetter.typeset(this.node);
      }
    }
  }]);

  return RenderedSVG;
}(RenderedCommon);

exports.RenderedSVG = RenderedSVG;
/**
 * A widget for displaying plain text and console text.
 */

var RenderedText = /*#__PURE__*/function (_RenderedCommon5) {
  _inherits(RenderedText, _RenderedCommon5);

  var _super8 = _createSuper(RenderedText);

  /**
   * Construct a new rendered text widget.
   *
   * @param options - The options for initializing the widget.
   */
  function RenderedText(options) {
    var _this8;

    _classCallCheck(this, RenderedText);

    _this8 = _super8.call(this, options);

    _this8.addClass('jp-RenderedText');

    return _this8;
  }
  /**
   * Render a mime model.
   *
   * @param model - The mime model to render.
   *
   * @returns A promise which resolves when rendering is complete.
   */


  _createClass(RenderedText, [{
    key: "render",
    value: function render(model) {
      return renderers.renderText({
        host: this.node,
        source: String(model.data[this.mimeType])
      });
    }
  }]);

  return RenderedText;
}(RenderedCommon);

exports.RenderedText = RenderedText;
/**
 * A widget for displaying deprecated JavaScript output.
 */

var RenderedJavaScript = /*#__PURE__*/function (_RenderedCommon6) {
  _inherits(RenderedJavaScript, _RenderedCommon6);

  var _super9 = _createSuper(RenderedJavaScript);

  /**
   * Construct a new rendered text widget.
   *
   * @param options - The options for initializing the widget.
   */
  function RenderedJavaScript(options) {
    var _this9;

    _classCallCheck(this, RenderedJavaScript);

    _this9 = _super9.call(this, options);

    _this9.addClass('jp-RenderedJavaScript');

    return _this9;
  }
  /**
   * Render a mime model.
   *
   * @param model - The mime model to render.
   *
   * @returns A promise which resolves when rendering is complete.
   */


  _createClass(RenderedJavaScript, [{
    key: "render",
    value: function render(model) {
      return renderers.renderText({
        host: this.node,
        source: 'JavaScript output is disabled in JupyterLab'
      });
    }
  }]);

  return RenderedJavaScript;
}(RenderedCommon);

exports.RenderedJavaScript = RenderedJavaScript;